module.exports = __webpack_public_path__ + "static/media/corona.d6a2d0b4.mp3";